import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="text-sm text-foreground-500">
      <ol className="flex flex-wrap items-center gap-1.5">
        {items.map((item, idx) => {
          const isLast = idx === items.length - 1;
          return (
            <li key={`${item.label}-${idx}`} className="flex items-center gap-1.5">
              {item.to && !isLast ? (
                <Link
                  to={item.to}
                  className="transition-colors hover:text-primary-600"
                >
                  {item.label}
                </Link>
              ) : (
                <span className={isLast ? "text-foreground-900" : ""}>
                  {item.label}
                </span>
              )}
              {!isLast && (
                <i
                  className="ri-arrow-right-s-line text-foreground-300"
                  aria-hidden="true"
                ></i>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}